// extracted by mini-css-extract-plugin
export default {"inputholder":"Feedback_inputholder__QM6EC","inputbox":"Feedback_inputbox__MPoK7","save":"Feedback_save__Gc8RR","cancel":"Feedback_cancel__rXDao"};